import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ReportCardsDetails from './ReportCardsDetails';

const styles = theme => ({
  closeIcon: {
    position: 'absolute',
    right: 20,
    top: 20,
  },
  content: {
    padding: isMobileApp
      ? 20
      : '20px 80px',
    margin: '10px auto',
    width: '100%',
    textAlign: 'left',
    color: '#222',
    boxSizing: 'border-box',
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

class ReportCardsDetailsDialog extends React.Component {
  render() {
    const {
      classes,
      isDialogOpen,
      onDialogClose,
      reportCard,
    } = this.props;

    return (
      <Dialog
        fullScreen={isMobileApp}
        scroll="paper"
        open={isDialogOpen}
        fullWidth
        maxWidth="md"
        onClose={onDialogClose}
        TransitionComponent={Transition}
        className="report-cards-details-dialog"
      >
        <IconButton
          aria-label="Close"
          onClick={onDialogClose}
          className={`report-cards-details-dialog-close-button ${classes.closeIcon}`}
        >
          <CloseIcon/>
        </IconButton>
        <div className={classes.content}>
          <ReportCardsDetails reportCard={reportCard} />
        </div>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(ReportCardsDetailsDialog)));
